import FeaturedGamesGrid from "./FeaturedGamesGrid";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";

const GamesSection = () => {
  const { settings } = useSiteSettings();

  return (
    <FeaturedGamesGrid
      queryKey="homepage-games"
      sectionLabel="Our Collection"
      sectionTitle={settings.homepage_featured_games_title || "Gather 'Round Ye Table"}
      viewAllHref="/games"
      viewAllLabel="View All"
    />
  );
};

export default GamesSection;
